import {observable, makeObservable, action} from 'mobx';

class Link {
  get id() {
    return `${this.from}-${this.to}`;
  }
  @observable
  from: string | null = null;

  @observable
  to: string | null = null;

  @observable
  touched: boolean = false;

  @action
  touch() {
    this.touched = true;
  }

  constructor(data = {}) {
    makeObservable(this);
    Object.assign(this, data);
  }
}

export default Link;
